import BaseService from "../base";
import type { PowerBiEmbedConfig } from "./types";

class PowerBiService extends BaseService {
  getEmbedConfig = (): Promise<PowerBiEmbedConfig> => {
    // @ts-ignore
    return this.sendSyncRequest("getPowerBiEmbedConfig", undefined);
  };
}

const powerBiService = new PowerBiService();

export default powerBiService;
